// extracted by mini-css-extract-plugin
export default {"box":"KEmkKL28wz8PPVsvsujT"};